import React, { Component } from 'react'
import { connect } from 'react-redux'
import zoneItemImage from '../../images/link-icons/ico_light.svg'
import { setSelectedControlZone } from '../../action/roomControlAction'

class LightZoneSelector extends Component {

    selectZone = (selectedZone, indexOfSelectedZone) => {
        //console.log("selectedZone", selectedZone)
        if (selectedZone.zoneId) {
            this.props.setSelectedControlZone(selectedZone);
        }
    }

    render() {
        return (
            <div
                id="ac-selection"
                class="tiles"
                style={this.props.selectedControlZone.zoneId ? { display: "none" } : {}}>
                <p><strong></strong></p>
                <ul class="tile-links" data-parent="ac-selection">
                    {
                        this.props.VDAZoneList.map((iterator, index) => {
                            if (iterator.lightCount !== 0) {
                                return (
                                    <li >
                                        <button className="button"
                                            data-target="temp-selection" onClick={() => { this.selectZone(iterator, index) }}>
                                            <img src={zoneItemImage} />
                                            {iterator.lightGroupLabel}
                                        </button>
                                    </li>
                                )
                            }
                        })
                    }
                </ul>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        //guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        selectedControlZone: state.store.roomControl.selectedControlZone,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        //seletedIndex: state.store.roomControl.seletedIndex
    }
}

export default connect(
    mapStateToProps,
    {
        setSelectedControlZone
        //     VDAStatusApi,
        //     setSelectedZone,
        //     restoreValue,
        //     TempChange
    }
)(LightZoneSelector);